import React, { useEffect, useLayoutEffect, useState } from 'react';
import StreamingService from '../../utils/StreamingService';
import propTypes from 'prop-types';
import InfoMessage from '../../components/InfoMessageBage/InfoMessage';
import Wrapper from '../../ui/Wrapper';
import { detectMobile } from '../../utils/UiHelper';
import 'css/LiveStream.scss';

const LiveStream = ({
    streamId = '',
    isHorse = false,
    streamUrl = '',
    groupName,
    sportId,
}) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [initialSetup, setInitialSetup] = useState(true);

    useEffect(() => {
        return () => {
            setErrorMessage('');
            if (window.player) {
                window.player.remove();
            }
        };
    }, []);

    useEffect(
        () => {
            if (!initialSetup && isHorse) {
                window.player.remove();
                initStream();
            }
        },
        [streamUrl]
    );

    useLayoutEffect(
        () => {
            if (streamId !== null && streamId.length > 0) {
                StreamingService.GetOnlineStream(streamId).then((res) => {
                    if (res.data) {
                        let config = {
                            id: 'playercontainer',
                            bufferTime: 5,
                            allowFullScreen:
                                !!detectMobile() ||
                                (groupName === 'eSoccer' && sportId === 1),
                        };
                        let player = new avvpl.setupPlayer(config);
                        player.load(res.data);

                        window.player = player;
                    } else {
                        setErrorMessage(res.errorMessage);
                    }
                });
            }
        },
        [streamId]
    );

    useLayoutEffect(() => {
        initStream();
        setInitialSetup(false);
    }, []);

    const initStream = () => {
        if (isHorse) {
            let config = {
                id: 'playercontainer',
                bufferTime: 5,
                fullscreen: false,
                allowFullScreen:
                    !!detectMobile() ||
                    (groupName === 'eSoccer' && sportId === 1),
            };
            let player = new avvpl.setupPlayer(config);
            player.load(streamUrl);

            window.player = player;
        }
    };
    const getPadding = () => {
        if (isHorse) {
            return detectMobile() ? '67px 0 0' : '0';
        } else {
            return detectMobile() ? '67px 15px 0' : '0';
        }
    };
    const getHeight = () => {
        return detectMobile()
            ? `${Math.round(window.innerWidth * 0.83)}px`
            : 'auto';
    };

    return (
        <>
            {errorMessage.length > 0 ? (
                <Wrapper
                    minHeight={getHeight()}
                    height={'auto'}
                    width={'100%'}
                    margin={'0'}
                    padding={getPadding()}
                    bgColor={detectMobile() ? '#fff' : 'transparent'}
                >
                    <InfoMessage text={errorMessage} blue aligned={'left'} />
                </Wrapper>
            ) : (
                <div
                    id="playercontainer"
                    style={{ borderRadius: '5px' }}
                    className={`${isHorse && 'isHorse'}`}
                />
            )}
        </>
    );
};

export default LiveStream;

LiveStream.propTypes = {
    streamId: propTypes.string,
};
